import { isArray } from 'util';
import { WorkingHoursValidationDetailSummary } from '../working-hours-validation-detail-summary';

export class WorkingHoursValidationDetailSummaryBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingHoursValidationDetailSummary(
        json.hash,
        json.userSubactivityHash,
        json.userSubactivityName,
        json.manufacturingOrderHash,
        json.manufacturingOrderCode,
        json.manufacturingOrderProject,
        json.manufacturingOrderProjectNumber
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WorkingHoursValidationDetailSummaryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-hours-validation-detail-summary.builder.ts